var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.iconRepeatable))])]}}],null,false,2774652452)},[_c('span',[_vm._v("This question collection is repeatable which means the user is allowed to complete all the fields in this collection an unlimited number of times.")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }